import { Checkbox } from "@graffer-inc/console-design-kit";
import React from "react";
import { ProcedureEntity } from "../../../../application/domain/procedures/procedure-entity";
import { BaseModal } from "../../../atoms/base-modal";

type Props = {
  isActive: boolean;
  procedure: ProcedureEntity;
  onCancel: () => void;
  onSave: (newValue: ProcedureEntity["customerDlConfig"]) => void;
};

export const CustomerDlPdfCfgModal: React.FC<Props> = ({
  isActive,
  procedure,
  onCancel,
  onSave,
}) => {
  const [newValue, setNewValue] = React.useState(
    procedure.customerDlConfig?.pdfDownloadConfig,
  );
  const disabled = React.useMemo(() => {
    return !!procedure.published || !procedure.hasPdfOutputSettingForDraft();
  }, [procedure]);

  return (
    <BaseModal
      isActive={isActive}
      title="申請者へのPDFマッピング提供"
      onClose={onCancel}
      style={{ width: "auto" }}
    >
      <section className="modal-card-body">
        <div className="field">
          <Checkbox
            label={"出力可否"}
            description={
              "PDFマッピングの結果を申請者も出力可能にする場合はチェックしてください。"
            }
            options={[
              {
                name: "PDFマッピングの結果を申請者も出力可能にする",
                value: "enabledCustomerDlPdf",
              },
            ]}
            values={newValue ? ["enabledCustomerDlPdf"] : []}
            onChange={({ target: { checked } }) => {
              setNewValue(checked ? { fileName: "" } : undefined);
            }}
            disabled={disabled}
          />
        </div>
        {!!newValue && (
          <>
            <div className="field mt-5">
              <label className="label">ダウンロード時のファイル名</label>
              <div className="control">
                <input
                  className="input"
                  placeholder="納入書.pdf"
                  onChange={({ target: { value } }) => {
                    setNewValue({
                      ...newValue,
                      fileName: value,
                    });
                  }}
                  disabled={disabled}
                  value={newValue?.fileName ?? ""}
                />
              </div>
            </div>
            <div className="field mt-5">
              <label className="label">ファイルの説明</label>
              <div className="control">
                <textarea
                  className="textarea"
                  placeholder="ダウンロード、押印したのち、最寄りのコンビニなどでお支払いください。"
                  disabled={disabled}
                  onChange={({ target: { value } }) => {
                    setNewValue({
                      ...newValue,
                      description: value,
                    });
                  }}
                >
                  {newValue?.description ?? ""}
                </textarea>
              </div>
            </div>
          </>
        )}
        {procedure.published ? (
          <>
            <p className="help is-danger mt-5">
              この設定は、手続き公開前にしか変更できません。
            </p>
          </>
        ) : !procedure.hasPdfOutputSettingForDraft() ? (
          <>
            <p className="help is-danger mt-5">
              PDFマッピング設定が存在しないので、変更できません。
            </p>
          </>
        ) : (
          <></>
        )}
      </section>
      <footer className="modal-card-foot">
        <button className="button is-fullwidth" onClick={onCancel}>
          キャンセル
        </button>
        <button
          className="button is-info is-fullwidth"
          onClick={() => {
            onSave({
              pdfDownloadConfig: newValue,
            });
          }}
          disabled={
            !!procedure.published || !procedure.hasPdfOutputSettingForDraft()
          }
        >
          保存する
        </button>
      </footer>
    </BaseModal>
  );
};
